import React, { useEffect, useState } from 'react';
import prevIcon from '../../../public/assets/images/prevIcon.png';
import nextIcon from '../../../public/assets/images/nextIcon.png';
import * as PDFJS from 'pdfjs-dist';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.mjs?worker';
PDFJS.GlobalWorkerOptions.workerPort = new pdfWorker();

const PreviewModal = ({ isOpen, onClose, file, onDownload, editUpdate }) => {
  if (!isOpen) return null;
  const [pdfPages, setPdfPages] = useState([]);
  const [pdfIndex, setPdfIndex] = useState(0);



  const loadPdf = async () => {
    // Handle PDF preview
    try {
      const doc = await PDFJS.getDocument(URL.createObjectURL(file?.preview))
        .promise;
      const pages = [];

      for (let i = 1; i <= doc.numPages; i++) {
        const page = await doc.getPage(i);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext('2d');

        await page.render({
          canvasContext: ctx,
          viewport,
        }).promise;
        pages.push(canvas.toDataURL('image/png'));
      }

      setPdfPages(pages);
      setPdfIndex(0);
    } catch (error) {
      console.error('PDF render error:', error);
    }
  };

  useEffect(() => {
    if (file.type === 'application/pdf') {
      loadPdf();
    }
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-3/5 max-w-md relative">
        <div className="flex justify-between items-center border-b p-4">
          <h3 className="text-[20px]  text-[#514D4C]">File Preview</h3>
          <button
            onClick={onClose}
            className="text-primary transition-colors text-2xl"
          >
            x
          </button>
        </div>
        <div className="p-4 w-full h-full">
          {file?.type?.includes('image') ? (
            <img
              src={URL.createObjectURL(file?.preview)}
              alt="File Preview"
              className="w-full h-64 object-contain"
            />
          ) : file?.type?.includes('pdf') ? (
            !pdfPages.length ? (
              <div className="flex justify-center items-center">Loading...</div>
            ) : (
              <div>
                <div className="border m-2">
                  <img
                    src={pdfPages[pdfIndex]}
                    alt="pdf page"
                    style={{ border: '1px solid #ccc' }}
                    className='"w-full max-h-[80vh] object-contain'
                  />
                </div>
                <div className="flex justify-center items-center mt-4 p-4">
                  <div className="flex gap-2">
                    <div>
                      <button
                        className={`${pdfIndex === 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        disabled={pdfIndex === 0 ? true : false}
                        onClick={() => {
                          if (pdfIndex === 0) {
                            return null;
                          } else {
                            setPdfIndex((prev) => prev - 1);
                          }
                        }}
                      >
                        <img src={prevIcon} alt="prev" width={30} height={30} />
                      </button>
                    </div>
                    <div>
                      {pdfIndex}/{pdfPages?.length - 1}
                    </div>
                    <div>
                      <button
                        className={`${pdfIndex >= pdfPages.length - 1 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        disabled={
                          pdfIndex >= pdfPages.length - 1 ? true : false
                        }
                        onClick={() => {
                          if (pdfIndex >= pdfPages.length - 1) {
                            return null;
                          } else {
                            setPdfIndex((prev) => prev + 1);
                          }
                        }}
                      >
                        <img src={nextIcon} alt="prev" width={30} height={30} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )
          ) : (
            <p className="text-gray-500">
              Preview not available for this file.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
